import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "@/router/permissionGuard"
//引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);


// swiper
import Swiper from "swiper";
import 'swiper/css/swiper.css';

// 引入 vue-awesome-swiper
// import VueAwesomeSwiper from 'vue-awesome-swiper'
 
//引入 vue-awesome-swiper 样式
// import 'swiper/css/swiper.css'

// 视频
import VideoPlayer from "vue-video-player"
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

Vue.use(VideoPlayer)


// axios
import api from "./api"
Vue.prototype.$api=api

// 初始化css样式
import 'normalize.css'
import "@/assets/css/reset.css"


// main.js
// 创建空的Vue实例
var eventBus = new Vue()
// 把Vue空实例挂载到Vue的原型上面
Vue.prototype.eventBus = eventBus

// 高德地图 设置JSCode安全密钥 
window._AMapSecurityConfig = {
  securityJsCode:'7a97b6668808d30b6934c36df411cae4',
}


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
